/**
 * Employee Incident Get Mapper
 * Maps transport layer DTOs to domain models for single incident detail lookup
 */
import type { LC_GetIncidentDetailOut, IncidentDetail } from '../types';
import { formatDateToDDMMYYYY } from './employeeIncidentCommon.mapper';

/**
 * Maps incident detail from backend to UI model
 */
export function mapIncidentDetailOut(out: LC_GetIncidentDetailOut): IncidentDetail {
  return {
    id: out.incidentId,
    errorType: out.errorTypeName || '-',
    incidentDate: formatDateToDDMMYYYY(out.incidentDate),
    checkInDate: formatDateToDDMMYYYY(out.checkInDate),
    checkInTime: out.checkInTime || '-',
    event: out.eventName || '-',
    location: out.locationName || '-',
    updatedAt: formatDateToDDMMYYYY(out.updatedAt),
    status: out.status || '-',
    employeeComment: out.employeeComment || '-',
    updateComment: out.updateComment || '-',
    employeeFullName: out.employeeFullName || '-',
    area: out.areaName || '-',
  };
}
